import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface vendorState {
	isLoading: boolean;
	vendorList: any;
	vendorDetail: any;
	totalVendor: number;
	vendorData: any;
	vendorOrder: any;
	totalVendorOrder: any;
	isLoadingID: boolean;
}

const initialState: vendorState = {
	isLoading: false,
	vendorDetail: {},
	vendorList: [],
	totalVendor: 0,
	vendorData: {},
	vendorOrder: [],
	totalVendorOrder: 0,
	isLoadingID: false
};

const vendorSlice = createSlice({
	name: 'vendor',
	initialState,
	reducers: {
		getAllVendorListInIt: state => {
			state.isLoading = true;
		},
		getAllVendorListSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			state.totalVendor = data.totalCount;
			state.vendorList = [...data.vendors];
		},
		getAllVendorListError: state => {
			state.isLoading = false;
			state.vendorList = [];
			state.totalVendor = 0;
		},
		deleteVendorInit: state => {
			state.isLoading = true;
		},
		deleteVendorSuccess: state => {
			// state.isLoading = false;
		},
		deleteVendorError: state => {
			state.isLoading = false;
		},

		getOrderDetailOfVendorInIt: state => {
			state.isLoadingID = true;
			// state.vendorOrder = [];
			// state.totalVendorOrder = 0;
		},
		getOrderDetailOfVendorSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoadingID = false;
			state.vendorOrder = [...data.resonse];
			state.totalVendorOrder = data.count;
		},
		getOrderDetailOfVendorError: state => {
			state.isLoadingID = false;
			state.vendorOrder = [];
			state.totalVendorOrder = 0;
		},
		getVendorByIdInIt: state => {
			state.isLoading = true;
		},
		getVendorByIdSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			state.vendorDetail = { ...action.payload.data.vendorIsAvailable };
		},
		getVendorByIdError: state => {
			state.isLoading = false;
		},
		clearVendorDetail: state => {
			state.vendorDetail = {};
		},
		addVendorInIt: state => {
			state.isLoading = true;
		},
		addVendorSuccess: state => {
			state.isLoading = false;
		},
		addVendorError: state => {
			state.isLoading = false;
		},
		updateVendorStatusInit: state => {
			state.isLoading = true;
		},
		updateVendorStatusSuccess: state => {
			// state.isLoading = true;
		},
		updateVendorStatusError: state => {
			state.isLoading = false;
		},
		updateVendorApprovalInit: state => {
			state.isLoading = true;
		},
		updateVendorApprovalSuccess: state => {
			// state.isLoading = true;
		},
		updateVendorApprovalError: state => {
			state.isLoading = false;
		}
	}
});

export const {
	updateVendorApprovalInit,
	updateVendorApprovalSuccess,
	updateVendorApprovalError,
	getAllVendorListError,
	getAllVendorListInIt,
	getAllVendorListSuccess,
	deleteVendorError,
	deleteVendorInit,
	deleteVendorSuccess,
	getVendorByIdError,
	getVendorByIdInIt,
	getVendorByIdSuccess,
	addVendorError,
	addVendorInIt,
	addVendorSuccess,
	clearVendorDetail,
	updateVendorStatusError,
	updateVendorStatusInit,
	updateVendorStatusSuccess,
	getOrderDetailOfVendorSuccess,
	getOrderDetailOfVendorError,
	getOrderDetailOfVendorInIt
} = vendorSlice.actions;

export default vendorSlice.reducer;
